import { useEffect, useRef } from 'react'

const GOOGLE_CLIENT_ID = '296673159657-sse1rme7sunt0f83i2c1pssbacs48t1n.apps.googleusercontent.com'

export default function GoogleSignInButton({ onCredential, disabled = false }) {
  const containerRef = useRef(null)
  const initialized  = useRef(false)

  useEffect(() => {
    if (initialized.current || disabled) return

    function init() {
      if (!window.google?.accounts?.id) return
      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: (response) => {
          if (response.credential) onCredential(response.credential)
        },
        ux_mode: 'popup',
      })
      if (containerRef.current) {
        window.google.accounts.id.renderButton(containerRef.current, {
          theme: 'outline',
          size: 'large',
          text: 'signin_with',
          locale: 'ru',
          width: 280,
        })
        initialized.current = true
      }
    }

    // Script may still be loading — poll briefly
    if (window.google?.accounts?.id) {
      init()
    } else {
      const t = setInterval(() => {
        if (window.google?.accounts?.id) { clearInterval(t); init() }
      }, 100)
      return () => clearInterval(t)
    }
  }, [onCredential, disabled])

  return (
    <div style={{ display: 'flex', justifyContent: 'center', opacity: disabled ? 0.4 : 1, pointerEvents: disabled ? 'none' : 'auto' }}>
      <div ref={containerRef} />
    </div>
  )
}
